/* eslint-disable */
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const perfilRepository = RepositoryFactory.get('perfil');

const state = {
  perfil: {
    id: null,
    instrutorCapacitacao: false,
    instrutorCultura: false,
    instrutorEsporte: false,
    areasCapacitacaoInstrutor: [],
    areasCultura: [],
    areasCulturaInstrutor: [],
    areasEsporte: [],
    areasEsporteInstrutor: [],
    areasPesquisa: [],
    areasProfissional: [],
    pathCurriculum: null,
    curriculumLattes: null,
    usuario: null
  },
  deficiencias: [],
  listaAreasPesquisa: [],
  listaAreasProfissional: [],
  listaAreasCultura: [],
  listaAreasEsporte: [],
  listaSetores: [],
  listaVinculos: [],
  listaCargos: [],
  listaFuncoes: [],
  listaNiveisGratificacoes: [],
  idiomas: [],
  perfilIdiomas: [],
  escolaridades: [],
  cursos: [],
  experienciasProfissioonais: [],
  preferencias: [],
  perfilPreferencias: [],
  itensPreferencia: [],
  loaded: false,
  loadedPreferencias: false
}

function sortAscNome(array) {
  return array.sort((a, b) => {
    return a.nome.localeCompare(b.nome);
  });
}

function sortAscInicio(array) {
  return array.sort((a, b) => {
    if (a.inicio > b.inicio) {
      return 1;
    }
    if (a.inicio < b.inicio) {
      return -1;
    }
    return 0;
  });
}

const actions = {
  load({commit}) {
    return new Promise(async (resolve) => {
      perfilRepository.get().then(async response => {
        let dados = response.data;

        if (dados) {
          let perfil = dados.PERFIL;
          if (!perfil.areasPesquisa) {
            perfil.areasPesquisa = [];
            perfil.areasCapacitacaoInstrutor = [];
            perfil.areasProfissional = [];
            perfil.areasCultura = [];
            perfil.areasCulturaInstrutor = [];
            perfil.areasEsporte = [];
            perfil.areasEsporteInstrutor = [];
            perfil.deficiencias = [];
          }
          let idiomas = sortAscNome(dados.IDIOMAS);
          let perfilIdiomas = dados.PERFIL_IDIOMAS.sort((a, b) => {
            return a.idioma.nome.localeCompare(b.idioma.nome);
          });
          let escolaridades = sortAscInicio(dados.ESCOLARIDADES);
          let experienciasProfissionais = sortAscInicio(dados.EXPERIENCIAS_PROFISSIONAIS);

          commit('SET_PERFIL', perfil);
          commit('SET_IDIOMAS', [...idiomas]);
          commit('SET_PERFIL_IDIOMAS', perfilIdiomas);
          commit('SET_ESCOLARIDADES', escolaridades);
          commit('SET_EXPERIENCIAS_PROFISSIONAIS', experienciasProfissionais);
        }
        resolve();
      });
    });
  },
  setPerfil({commit}, perfil) {
    commit('SET_PERFIL', perfil);
  },
  setListaAreasPesquisa({commit}, lista) {
    commit('SET_LISTA_AREAS_PESQUISA', lista);
  },
  setListaAreasProfissional({commit}, lista) {
    commit('SET_LISTA_AREAS_PROFISSIONAL', lista);
  },
  setListaAreasCultura({commit}, lista) {
    commit('SET_LISTA_AREAS_CULTURA', lista);
  },
  setListaAreasEsporte({commit}, lista) {
    commit('SET_LISTA_AREAS_ESPORTE', lista);
  },
  setIdiomas({commit}, idiomas) {
    commit('SET_IDIOMAS', idiomas);
  },
  setPerfilIdiomas({commit}, perfilIdiomas) {
    commit('SET_PERFIL_IDIOMAS', perfilIdiomas);
  },
  setCursos({commit}, cursos) {
    commit('SET_CURSOS', cursos);
  },
  setEscolaridades({commit}, escolaridades) {
    commit('SET_ESCOLARIDADES', escolaridades);
  },
  setExperienciasProfissionais({commit}, experiencias) {
    commit('SET_EXPERIENCIAS_PROFISSIONAIS', experiencias);
  },
  setPreferencias({commit}, Preferencias) {
    commit('SET_PREFERENCIAS', Preferencias);
  },
  setPerfilPreferencias({commit}, perfilPreferencias) {
    commit('SET_PERFIL_PREFERENCIAS', perfilPreferencias);
  },
  setLoaded({commit}, status) {
    commit('SET_LOADED', status);
  },
  setLoadedPreferencias({commit}, status) {
    commit('SET_LOADED_PREFERENCIAS', status);
  }
}

const mutations = {
  SET_AREAS_PERFIL: (st, areasPerfil) => {
    areasPerfil = areasPerfil.sort((a, b) => a.nome.localeCompare(b.nome));

    const areasPesquisa = [];
    const areasProfissional = [];
    const areasCultura = [];
    const areasEsporte = [];

    areasPerfil.forEach(a => {
      switch (a.tipo) {
        case 'PESQUISA':
          areasPesquisa.push(a);
          break;
        case 'PROFISSIONAL':
          areasProfissional.push(a);
          break;
        case 'CULTURA':
          areasCultura.push(a);
          break;
        case 'ESPORTE':
          areasEsporte.push(a);
          break;
      }
    });

    st.listaAreasPesquisa = areasPesquisa;
    st.listaAreasProfissional = areasProfissional;
    st.listaAreasCultura = areasCultura;
    st.listaAreasEsporte = areasEsporte;
  },
  SET_PERFIL: (st, perfil) => {
    st.perfil = perfil;
  },
  SET_DEFICIENCIAS: (st, deficiencias) => {
    st.deficiencias = deficiencias;
  },
  SET_IDIOMAS: (st, idiomas) => {
    st.idiomas = idiomas;
  },

  SET_LISTA_SETORES: (st, lista) => {
    st.listaSetores = lista;
  },
  SET_LISTA_VINCULOS: (st, lista) => {
    st.listaVinculos = lista;
  },
  SET_LISTA_CARGOS: (st, lista) => {
    st.listaCargos = lista;
  },
  SET_LISTA_FUNCOES: (st, lista) => {
    st.listaFuncoes = lista;
  },
  SET_LISTA_NIVEIS_GRATIFICACOES: (st, lista) => {
    st.listaNiveisGratificacoes = lista;
  },

  SET_PERFIL_IDIOMAS: (st, perfilIdiomas) => {
    st.perfilIdiomas = perfilIdiomas;
  },
  SET_ESCOLARIDADES: (st, escolaridades) => {
    st.escolaridades = escolaridades;
  },
  SET_EXPERIENCIAS_PROFISSIONAIS: (st, experienciasProfissioonais) => {
    st.experienciasProfissioonais = experienciasProfissioonais;
  },
  SET_PREFERENCIAS: (st, preferencias) => {
    st.preferencias = preferencias;
  },
  SET_PERFIL_PREFERENCIAS: (st, perfilPreferencias) => {
    st.perfilPreferencias = perfilPreferencias;
  },
  SET_ITENS_PREFERENCIA: (st, itensPreferencia) => {
    st.itensPreferencia = itensPreferencia;
  },
  SET_LOADED: (st, status) => {
    st.loaded = status;
  },
  SET_CURSOS: (st, cursos) => {
    st.cursos = cursos;
  },
  SET_LOADED_PREFERENCIAS: (st, status) => {
    st.loadedPreferencias = status;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
